import { booleanFilter } from '@/utils/arrayUtils';
import { isContentPayloadCached, isAssetCached } from '@/utils/cache';

export const useOfflineAvailability = () => {
  const checkOfflineAvailability = async (unit: any) => {
    const isContentPayloadCachedResult = await isContentPayloadCached(unit.id);

    const allSlideAssets = Array.from(
      new Set(
        Object.values(unit.derivedData.slideGroups).flatMap((slideGroup: any) =>
          Object.values(slideGroup.slides)
            .filter(
              (slide: any) =>
                (slide.contentType?.startsWith('image/') ||
                  slide.contentType?.startsWith('video/')) &&
                typeof slide.asset === 'string',
            )
            .map((slide: any) => slide.asset.split('?')[0]),
        ),
      ),
    ).filter(booleanFilter);

    const isAllSlideAssetsCachedArr = await Promise.all(
      allSlideAssets.map(async (asset) => isAssetCached(asset)),
    );

    const isAllSlideAssetsCached = isAllSlideAssetsCachedArr.every(
      (isCached) => isCached === true,
    );
    return isContentPayloadCachedResult && isAllSlideAssetsCached;
  };

  return { checkOfflineAvailability };
};
